import { render, staticRenderFns } from "./index.vue?vue&type=template&id=10aef44a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=10aef44a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aef44a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10aef44a')) {
      api.createRecord('10aef44a', component.options)
    } else {
      api.reload('10aef44a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=10aef44a&scoped=true", function () {
      api.rerender('10aef44a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/OnlineSupport/index.vue"
export default component.exports